import { render, staticRenderFns } from "./withdrawDetail.vue?vue&type=template&id=6b155414&scoped=true&"
import script from "./withdrawDetail.vue?vue&type=script&lang=js&"
export * from "./withdrawDetail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawDetail.vue?vue&type=style&index=0&id=6b155414&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b155414",
  null
  
)

export default component.exports